import firebase from "firebase/app";
import 'firebase/firestore';

export class Impressaorelatoriofaturamento {

    
    constructor(dadosParaImpressao, dataini, datafim, qtd,totalfaturado,totalpago) {
      this.dadosParaImpressao = dadosParaImpressao;
      this.datinicio = dataini;//= new Date(dataini.seconds*1000).toLocaleString("pt-BR");
      this.datafim =datafim; //=new Date(datafim.seconds*1000).toLocaleString("pt-BR");
     this.qtd = qtd; //dadosParaImpressao.lenght();
     this.valortotalfaturado=totalfaturado;
     this.valortotalpagomotoristas=totalpago;
      
    }  
  
    async PreparaDocumento() {
        
      const corpoDocumento = this.CriaCorpoDocumento();
      const documento = this.GerarDocumento();
      return documento;
    }

    
  
    CriaCorpoDocumento() {
      
     /* const body = this.dadosParaImpressao.map((prod) => {
        return [
          { text: prod.nome, fontSize: 8 },
          { text: prod.qtdEstoque, fontSize: 8 },
          { text: prod.qtdVendido, fontSize: 8 },
        ];
      });*/

      const body = (() => {
        return [{
            
        }];
      })
  
     
  
      let content = [body];
      
      return content;
    }
    
    
 GerarDocumento() {
        

        
      const documento = {
        pageSize: 'A4',
        //pageMargins: [14, 53, 14, 48],
        pageOrientation: 'portait',
        info: {
            title: 'Relatório de Faturamento',
          },
        content: [
       

            {
                alignment: 'center',
                columns: [
                
    
                        {text:'Relatório de Faturamento' , style: 'header' },
                            
                           
                        
                ] 
            },
           
            {
               
                columns: [
                
    
                        {text:'Data Inicial:'   },
                        {text:this.datinicio  },
                            
                           
                        
                ] 
            },
            {
               
                columns: [
                
    
                        {text:'Data Final:'   },
                        {text:this.datafim  },
                            
                           
                        
                ] 
            },
           
            {
               
                columns: [
                
    
                        {text:'Nº de Motoristas: '   },
                        {text:this.qtd  },
                            
                           
                        
                ] 
            },
            
            {
               
                columns: [
                
    
                        {text:'Valor total Faturado pela Empresa R$ '   },
                        {text:this.valortotalfaturado  },
                            
                           
                        
                ] 
            },
            {
               
                columns: [
                
    
                        {text:'Valor total Pago aos Motoristas R$ '   },
                        {text:this.valortotalpagomotoristas  },
                            
                           
                        
                ] 
            },
            
            '\n\n',
            
                  
                
                               

           this.dadosParaImpressao.map((item)=>{
            
           
               return[
                '\n\n',
                {
                    columns: [
                        
                        {text:'Nome:' },
                        {text:item.nomemotorista},
                        
                        
                ] },
                   
                {
                
                    columns:[
                
                    {text:'Matrícula:' },
                    {text:item.matricula},
                    {text:'Categoria do Motorista' },
                    {text:item.catmotorista },
                    
                    
            ] },

            {
                columns: [
                    
                    {text:'Valor Total Pago ao Motorista R$:' },
                    {text:item.totalpagomotorista},
                    
                    
            ] },
            {
            columns: [
                
                {text:'Valor Total Faturado pela Empresa R$:' },
                {text:item.totalfaturadoempresa},
                
                
        ] },
       
        item.deslocs.map((item2)=>{
            return[
                '\n',         
                   
                {
                
                    columns:[
                
                    {text:'Nº Deslocamento:' },
                    {text:item2.deslocamento},
                    {text:'Data do Deslocamento:' },
                    {text:item2.data },
                    
                    
            ] },

           
            {
                columns: [
                    {text:'Faturado (F.) R$' },
                    {text:item2.valorfaturadoempresa},
                    {text:'Pago (P.) R$' },
                    {text:item2.valorpagomotorista},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Hora extra 50%' },
                    {
                        columns:[

                           'horas:', {text:item2.hora50},
                            'minutos:',{text:item2.minuto50},
                        ]
                    },
                                      
                                      
                    
                    
            ] },

            {
                columns: [
                    {text:'F. hora extra 50% R$' },
                    {text:item2.valorfaturadohora50},
                    {text:'P. hora extra 50% R$' },
                    {text:item2.valorpagohora50},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Hora extra 100%' },
                    {
                        columns:[

                           'horas:', {text:item2.hora100},
                            'minutos:',{text:item2.minuto100},
                        ]
                    },
                                      
                                      
                    
                    
            ] },

            {
                columns: [
                    {text:'F. hora extra 100% R$' },
                    {text:item2.valorfaturadohora100},
                    {text:'P. hora extra 100% R$' },
                    {text:item2.valorpagohora100},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Adicional noturno' },
                    {
                        columns:[

                           'horas:', {text:item2.adicionalnhora},
                            'minutos:',{text:item2.adicionalnminuto},
                        ]
                    },
                                      
                                      
                    
                    
            ] },

            {
                columns: [
                    {text:'F. adicional noturno R$' },
                    {text:item2.valorfaturadoadicionaln},
                    {text:'P. adicional noturno R$' },
                    {text:item2.valorpagoadicionaln},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Espera' },
                    {
                        columns:[

                           'horas:', {text:item2.esperahora},
                            'minutos:',{text:item2.esperaminuto},
                        ]
                    },
                                      
                                      
                    
                    
            ] },

            {
                columns: [
                    {text:'F. hora espera R$' },
                    {text:item2.valorfaturadoespera},
                    {text:'P. hora espera R$' },
                    {text:item2.valorpagoespera},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Sobreviso' },
                    {
                        columns:[

                           'horas:', {text:item2.sobreavisohora},
                            'minutos:',{text:item2.sobreavisominuto},
                        ]
                    },
                                      
                                      
                    
                    
            ] },

            {
                columns: [
                    {text:'F. hora sobreaviso R$' },
                    {text:item2.valorfaturadosobreaviso},
                    {text:'P. sobreaviso R$' },
                    {text:item2.valorpagosobreaviso},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Café' },
                    {
                        columns:[

                           'Qtd:', {text:item2.cafe},
                            
                        ]
                    },
                                      
                                      
                    
                    
            ] },

            {
                columns: [
                    {text:'F. café R$' },
                    {text:item2.valorfaturadocafe},
                    {text:'P. café R$' },
                    {text:item2.valorpagocafe},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Almoço' },
                    {
                        columns:[

                           'Qtd:', {text:item2.almoco},
                            
                        ]
                    },
                                      
                                      
                    
                    
            ] },

            {
                columns: [
                    {text:'F. almoço R$' },
                    {text:item2.valorfaturadoalmoco},
                    {text:'P. almoço R$' },
                    {text:item2.valorpagoalmoco},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Jantar' },
                    {
                        columns:[

                           'Qtd:', {text:item2.janta},
                            
                        ]
                    },
                                      
                                      
                    
                    
            ] },

            {
                columns: [
                    {text:'F. jantar R$' },
                    {text:item2.valorfaturadojanta},
                    {text:'P. jantar R$' },
                    {text:item2.valorpagojanta},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Banho' },
                    {
                        columns:[

                           'Qtd:', {text:item2.banho},
                            
                        ]
                    },
                                      
                                      
                    
                    
            ] },

            {
                columns: [
                    {text:'F. banho R$' },
                    {text:item2.valorfaturadobanho},
                    {text:'P. banho R$' },
                    {text:item2.valorpagobanho},
                    
                    
                    
            ] },

            {
                columns: [
                    {text:'Pernoite' },
                    {
                        columns:[

                           'Qtd:', {text:item2.pernoite},
                            
                        ]
                    },
                                      
                                      
                    
                    
            ] },
            {
                columns: [
                    {text:'F. pernoite R$' },
                    {text:item2.valorfaturadopernoite},
                    {text:'P. pernoite R$' },
                    {text:item2.valorpagopernoite},
                    
                    
                    
            ] },
        ]

        })
        
                
            ];
            
            
           }),
            
           '\n\n',
            
        ],
      
          styles: {
            header: {
                fontSize: 13,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 12,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: 'black'
            }
        },
        defaultStyle: {
            // alignment: 'justify'
            fontSize: 11,
        }
  
    };
      return documento;
    }
  }